// @flow

import * as React from 'react';

import clsx from 'clsx';

import styles from './Header.scss';

export type Props = {
  controls?: React.Node,
  widgets?: React.Node,
  className?: string,
};

function Header({ controls, widgets, className }: Props): React.MixedElement {
  return (
    <header role="banner" className={clsx(styles.root, className)}>
      <div className={styles.container}>
        {
          // $FlowFixMe[sketchy-number-and]
          controls && <nav className={styles.controls}>{controls}</nav>
        }
        {
          // $FlowFixMe[sketchy-number-and]
          widgets && (
            <div id="layout-main-navigation" className={styles.widgets}>
              {widgets}
            </div>
          )
        }
      </div>
    </header>
  );
}

export { Header };
